import type { EmissionReportLogEntry } from '../../types/entities';
import { emissionFieldLabel } from './importableEmissionFields.js';

/**
 * Deutsche Beschriftung eines Protokolleintrags: Feldbeschriftung und Matrixnummer, ` · `
 * verbunden. Seit der Durchsprache vom 14.09.2026 (Punkt 3, WR-03) trägt `entry.message` keinen
 * Feldschlüssel mehr — die Beschriftung kommt ausschließlich von hier. Genutzt sowohl von der
 * Hinweisliste der Vorschau (`PreviewNotes`) als auch von der Protokollliste im Stand „nicht
 * lesbar“ (`EmissionReportDetailPage`), damit beide dieselbe Beschriftung vor derselben Meldung
 * zeigen.
 */
export function logEntryLabel(entry: Pick<EmissionReportLogEntry, 'field' | 'measurement'>): string | null {
  const parts = [
    entry.field !== null ? emissionFieldLabel(entry.field) : null,
    entry.measurement !== null ? `Messung ${entry.measurement}` : null,
  ].filter((part): part is string => part !== null);

  return parts.length > 0 ? parts.join(' · ') : null;
}
